"use strict";

import querystring from "querystring";

export default class Nominatim {
	
	constructor() {
		this.xhr = new XMLHttpRequest();
		this.queue = [];
	}
	
	pushQueue(position, callback) {
		this.queue.push({
			position: position,
			callback: callback || function(error, address){}
		});
	}

	next() {
		
		if (!this.queue[0])
			return;
		
		var position = this.queue[0].position;
		var callback = this.queue[0].callback;
		
		this.xhr.onreadystatechange = () => {
			if(this.xhr.readyState != 4)
				return;
			
			if (this.xhr.responseText) {
				var response = JSON.parse(this.xhr.responseText);
				callback(null, this.constructor.getFullAddressFromOSMResponse(response));
			}
			else if (this.xhr.status != 200 && this.xhr.status != 307 && this.xhr.status != 302) {
				callback(new Error());
				return;
			}
			
			this.queue.splice(0, 1);
			this.next();
		};
		
		this.xhr.open('GET', this.constructor.URL + this.constructor.getURLQuery(position));
		this.xhr.setRequestHeader("Content-type", "application/json");
		this.xhr.send();
	}
	
	geocode(position, callback) {
		this.pushQueue(position, callback);
		this.next();
	}
	
	static getFullAddressFromOSMResponse(response) {
		
		var addressParts = [[], [], []];
		
		// irányítószám és város
		if (response.address.postcode)
			addressParts[0].push(response.address.postcode);
		
		if (response.address.city)
			addressParts[0].push(response.address.city);
		else if (response.address.town)
			addressParts[0].push(response.address.town);
		else if (response.address.village)
			addressParts[0].push(response.address.village);
		
		if (response.address.city_district)
			addressParts[0].push(response.address.city_district);
		
		// cím
		if (response.address.road)
			addressParts[1].push(response.address.road);
		
		if (response.address.house_number)
			addressParts[1].push(response.address.house_number);
		
		// ország
		if (response.address.country)
			addressParts[2].push(response.address.country);
		
		return addressParts.map(function(mainPart){
			return mainPart.filter(function(subPart){
				return subPart
			}).join(' ');
		}).filter(function(mainPartString){
			return mainPartString;
		}).join(', ');
	}

	// ezt majd bővíteni kell geopoint-ra
	static positionToLatLng(position) {
		return {lat: position.lat(), lng: position.lng()};
	}

	static getURLQuery(position) {
		var latLng = this.positionToLatLng(position);
		var request = {
			lat: latLng.lat,
			lon: latLng.lng,
			format: 'json',
			addressdetails: 1
		};
		return '?' + querystring.stringify(request);
	}
}

Nominatim.URL = "https://nominatim.openstreetmap.org/reverse";


// WEBPACK FOOTER //
// ./~/vwa/geocode/Nominatim.js